/**
 * @prettier
 */

import { useEffect, useState } from "react";

const LANDSCAPE_QUERY = "(orientation: landscape)";

function getLandscapeMatches() {
    if (typeof window === "undefined") {
        return false;
    }
    return window.matchMedia(LANDSCAPE_QUERY).matches;
}

export function usePortraitOrientationGate(enabled) {
    const [isLandscape, setIsLandscape] = useState(() =>
        enabled ? getLandscapeMatches() : false
    );

    useEffect(() => {
        if (!enabled || typeof window === "undefined") {
            setIsLandscape(false);
            return;
        }

        const mql = window.matchMedia(LANDSCAPE_QUERY);
        const sync = () => setIsLandscape(mql.matches);

        sync();

        if (mql.addEventListener) {
            mql.addEventListener("change", sync);
        } else {
            mql.addListener(sync);
        }

        return () => {
            if (mql.removeEventListener) {
                mql.removeEventListener("change", sync);
            } else {
                mql.removeListener(sync);
            }
        };
    }, [enabled]);

    return enabled && isLandscape;
}
